/**
 * Sapp's Fitness — Home Page
 * Design: Crimson Red & Gold with near-black dark accents
 * Sections: Hero → Pillars → About → Programs → Nutrition → Process → SocialStrip → Results → Reviews → TransformBanner → Testimonials → FAQ → Contact → Footer
 */
import { lazy, Suspense, useEffect } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import PillarsSection from "@/components/PillarsSection";
import ContactSection from "@/components/ContactSection";
import { contactFormSelector, scrollToContactForm } from "@/lib/contactFormNavigation";

// Lazy load below-fold sections to improve initial load time
const AboutSection = lazy(() => import("@/components/AboutSection"));
const ProgramsSection = lazy(() => import("@/components/ProgramsSection"));
const NutritionSection = lazy(() => import("@/components/NutritionSection"));
const ProcessSection = lazy(() => import("@/components/ProcessSection"));
const SocialProofStrip = lazy(() => import("@/components/SocialProofStrip"));
const ResultsSection = lazy(() => import("@/components/ResultsSection"));
const ReviewsWidgetSection = lazy(() => import("@/components/ReviewsWidgetSection"));
const TransformationBanner = lazy(() => import("@/components/TransformationBanner"));
const TestimonialsSection = lazy(() => import("@/components/TestimonialsSection"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const Footer = lazy(() => import("@/components/Footer"));
const StickyCTA = lazy(() => import("@/components/StickyCTA"));

export default function Home() {
  useEffect(() => {
    if (window.location.hash !== contactFormSelector) return;

    requestAnimationFrame(() => scrollToContactForm());
  }, []);

  return (
    <div
      className="min-h-screen"
      style={{ background: "white", color: "oklch(0.18 0.04 260)" }}
    >
      <Navbar />
      <main id="main-content">
        <HeroSection />
        <PillarsSection />
        <Suspense fallback={null}>
          <AboutSection />
          <ProgramsSection />
          <NutritionSection />
          <ProcessSection />
          <SocialProofStrip />
          <ResultsSection />
          <ReviewsWidgetSection />
          <TransformationBanner />
          <TestimonialsSection />
          <FAQSection />
        </Suspense>
        <ContactSection />
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <StickyCTA />
      </Suspense>
    </div>
  );
}
